/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown> }} Task_Catalog_Issue_StageInputs */

const en_task_catalog_issue_stage = /** @type {(inputs: Task_Catalog_Issue_StageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} must move the case to Analysis.`)
};

const pt_br2_task_catalog_issue_stage = /** @type {(inputs: Task_Catalog_Issue_StageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} deve mover o caso para Análise.`)
};

/**
* | output |
* | --- |
* | "{task} must move the case to Analysis." |
*
* @param {Task_Catalog_Issue_StageInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_issue_stage = /** @type {((inputs: Task_Catalog_Issue_StageInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Issue_StageInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_issue_stage(inputs)
	return pt_br2_task_catalog_issue_stage(inputs)
});